import React from 'react'
import * as Styled from './styled'
import * as TestIds from './testIds'
import { TOUR_NEXT_COPY, TOUR_DONE_COPY } from './copy'
import { TourDots } from './TourDots'

export interface TourProps {
  component: React.ReactNode
  index: number
  stepCount: number
  onNextClick: (e: React.SyntheticEvent) => void
  onCloseClick: (e: React.SyntheticEvent) => void
}

export const TourBase: React.FC<TourProps> = ({
  component,
  index,
  stepCount,
  onNextClick,
  onCloseClick,
}) => {
  const isLastStep = index === stepCount - 1

  return (
    <Styled.TourContainer>
      <Styled.TourBody>{component}</Styled.TourBody>
      <Styled.TourFooter>
        <Styled.TourStepDotsContainer>
          <TourDots numberOfDots={stepCount} selectedIndex={index} />
        </Styled.TourStepDotsContainer>
        {!isLastStep && (
          <Styled.TourCTAButton
            data-test={TestIds.TOUR_NEXT_TEST_ID}
            size="large"
            onClick={onNextClick}
            tabIndex={0}
          >
            {TOUR_NEXT_COPY}
          </Styled.TourCTAButton>
        )}
        {isLastStep && (
          <Styled.TourCTAButton
            data-test={TestIds.TOUR_DONE_TEST_ID}
            size="large"
            onClick={onCloseClick}
          >
            {TOUR_DONE_COPY}
          </Styled.TourCTAButton>
        )}
      </Styled.TourFooter>
    </Styled.TourContainer>
  )
}
